<template>
  <div class="forum-Management-modular">
    <div class="forum-header-bar">
      <div class="forum-header-bar-center">
        <el-row :gutter="20">
          <el-col :span="18" :xs="24">
            <div class="left-bar-item-modualr">
              <!-- <div :class="(headerBarTypeID == item.forum_id ? 'header-bar-item header-bar-item-active' : 'header-bar-item')"
                v-for="(item, index) in headerBar" :key="index" @click="clickBar(item.forum_id, item.type_name)">
                {{ item.type_name }}
              </div> -->
              <div
                :class="
                  headerBarTypeID == item.id
                    ? 'header-bar-item header-bar-item-active'
                    : 'header-bar-item'
                "
                v-for="(item, index) in headerBar"
                :key="index"
                @click="clickBar(item.id, item.forum_id, item.type_name)"
              >
                {{ item.type_name }}
              </div>
            </div>
          </el-col>
          <el-col :span="6" :xs="24">
            <div class="right-release-modualr">
              <a href="#mubiao" class="release-btn">{{ pageTextArr[0] }}</a>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="forum-Management-body-modualr">
      <div class="forum-Management-header">
        <el-row :gutter="20">
          <el-col :span="14" :xs="8">
            <div class="header-item">{{ pageTextArr[1] }}</div>
          </el-col>
          <el-col :span="2" :xs="4">
            <div class="header-item">{{ pageTextArr[2] }}</div>
          </el-col>
          <el-col :span="2" :xs="4">
            <div class="header-item">{{ pageTextArr[3] }}</div>
          </el-col>
          <el-col :span="6" :xs="8">
            <div class="header-item">{{ pageTextArr[4] }}</div>
          </el-col>
        </el-row>
      </div>
      <div class="forum-Management-body" v-loading="forumListLoading">
        <div v-if="forumList.length == 0" class="my-evaluate-bodu-none">
          <img class="none-icon" src="../assets/public/none-icon.png" alt="" />
          <p class="none-title">{{ pageTextArr[5] }}</p>
        </div>
        <div
          v-else
          class="forum-item"
          v-for="(item, index) in forumList"
          :key="index"
        >
          <el-row :gutter="20">
            <el-col :span="14" :xs="8">
              <div class="theme-item">
                <div class="left-img-item">
                  <img
                    v-if="item.type_id == 1"
                    class="type-icon"
                    src="../assets/forum/problem-feedback-icon.png"
                    alt=""
                  />
                  <img
                    v-else-if="item.type_id == 2"
                    class="type-icon"
                    src="../assets/forum/seek-help-icon.png"
                    alt=""
                  />
                  <img
                    v-else-if="item.type_id == 3"
                    class="type-icon"
                    src="../assets/forum/discuss-icon.png"
                    alt=""
                  />
                </div>
                <div class="right-problem-item">
                  <div class="problem-title" @click="toForumDetail(item.id)">
                    {{ item.title == "" ? "-" : item.title }}
                  </div>
                  <div class="problem-content">
                    <div v-html="item.detail == '' ? '-' : item.detail"></div>
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :span="2" :xs="3">
              <div class="reply-item">{{ item.comment }}</div>
            </el-col>
            <el-col :span="2" :xs="3">
              <div class="see-item">{{ item.click }}</div>
            </el-col>
            <el-col :span="6" :xs="8">
              <div class="final-reply-item">
                <div class="left-item" v-if="!item.reply_user == ''">
                  <img class="final-reply-face" :src="item.head_img" alt="" />
                </div>
                <div class="right-item" v-if="!item.reply_user == ''">
                  <div class="final-reply-uaer-name">
                    {{ item.reply_user == "" ? "-" : item.reply_user }}
                  </div>
                  <div class="final-reply-uaer-time">{{ changeTime(item.reply_time) }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="pagination-footer-modualr">
          <el-pagination
            :pager-count="11"
            background
            layout="prev, pager, next"
            :total="pageCount"
            @current-change="handleCurrentChange()"
          >
          </el-pagination>
        </div>
      </div>
      <div class="forum-Management-release-modualr" id="mubiao">
        <div class="release-header">
          <div class="select-title-modualr">
            <el-select v-model="selectTitle" :placeholder="pageTextArr[6]">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="input-title-modular">
            <el-input
              v-model="inputTitle"
              :placeholder="pageTextArr[7]"
            ></el-input>
          </div>
        </div>
        <div class="release-problem-modular">
          <el-input
            type="textarea"
            :rows="4"
            :placeholder="pageTextArr[8]"
            v-model="problemTextArea"
          >
          </el-input>
        </div>
        <el-button class="release-btn" @click="addBlog()">{{
          pageTextArr[9]
        }}</el-button>
      </div>
    </div>
    <div></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currLanguage: localStorage.getItem("curLanguageType"),
      headerBarTypeID: 997,
      headerBarTypeIDTitle: "",
      headerForumId: 1,
      page: 1,
      pageSize: 10,
      pageCount: 1, //总页数
      headerBar: [
        {
          forum_id: 1,
          id: 997,
          type_name: "最新发帖",
        },
        {
          forum_id: 2,
          id: 998,
          type_name: "最新回复",
        },
        {
          forum_id: 3,
          id: 999,
          type_name: "热门",
        },
      ], //论坛类型
      headerBar1: [],
      forumList: [], //论坛列表
      forumListLoading: false, //loading
      options: [],
      selectTitle: "",
      inputTitle: "",
      problemTextArea: "",
      pageTextArr: [
        "发布帖子",
        "主题",
        "回复",
        "查阅",
        "最后回复",
        "暂无数据",
        "请选择主题分类",
        "请输入标题",
        "请输入内容",
        "发布",
        "发布成功，待审核",
        "发布失败",
      ],
    };
  },
  methods: {
    /**
     * 分页点击
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.page = val;
      this.getForumList();
    },

    /**
     * 论坛类型点击
     * @param {*} id
     * @param {*} title
     */
    clickBar(id, forum_id, title) {
      let that = this;
      that.headerBarTypeID = id;
      that.headerBarTypeIDTitle = title;
      that.headerForumId = forum_id;
      // 获取论坛列表
      that.getForumList();
    },

    /**
     * 论坛详情
     * @param {*} id
     */
    toForumDetail(id) {
      this.$router.push({
        path: "/forumDetail",
        query: { title: this.headerBarTypeIDTitle, uuid: id },
      });
    },

    /**
     * 获取论坛类型列表
     */
    getUserBlogType() {
      let that = this;
      let data = {
        page: 1,
        pagesize: 100,
      };

      this.$http.getUserBlogType(
        data,
        (res) => {
          if (res.ret == 1) {
            that.headerBar.push(...res.data);
            // that.headerBar1 = res.data
            // console.log("that.headerBar", that.headerBar);
            that.headerBarTypeID = that.headerBar[0].id;
            that.headerBarTypeIDTitle = that.headerBar[0].type_name;

            if (
              that.headerBar.length > 0 &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.translateApiData(that.headerBar, "type_name");
            }
            // 回复的主题分类
            res.data.forEach((v) => {
              if (v.type_name != "最新发帖") {
                that.options.push({
                  value: v.id,
                  label: v.type_name,
                });
              }
            });
            // 论坛列表
            that.getForumList();
          } else {
            this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 获取论坛列表
     */
    getForumList() {
      let that = this;
      // loading
      that.forumListLoading = true;
      let data = {
        page: that.page,
        pagesize: that.pageSize,
        type_id: that.headerBarTypeID,
        forum_id: that.headerForumId,
        type: null,
      };
      if (that.headerForumId) {
        data.type = 2;
      }
      this.$http.forumList(
        data,
        (res) => {
          if (res.ret == 1) {
            that.pageCount = parseInt(res.total);
            that.forumList = res.forumList;
            that.forumListLoading = false;
            if (that.forumList.length > 0) {
              that.translateApiData(res.forumList, "title");
              that.translateApiData(res.forumList, "detail");
            }
          } else {
            that.forumList = [];
            that.forumListLoading = false;
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          that.forumList = [];
          that.forumListLoading = false;
          // this.$message.error(res.msg);
        }
      );
    },

    /**
     * 发布帖子
     */
    addBlog() {
      let that = this;
      if (this.$parent.tipsLogin()) return;
      let data = {
        type_id: that.selectTitle,
        title: that.inputTitle,
        detail: that.problemTextArea,
      };
      this.$http.addBlog(
        data,
        (res) => {
          if (res.ret == 1) {
            // 论坛列表
            that.getForumList();
            //  清空
            that.inputTitle = "";
            that.problemTextArea = "";
            // this.$message.success(res.msg);
            this.$message.warning(this.pageTextArr[10]);
          } else {
            this.$message.error(this.pageTextArr[11]);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
    },
    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, title) {
      let that = this;
      let newTextArr = [];
      data.forEach((v, i) => {
        for (const key in v) {
          if (key == title) {
            newTextArr.push(v[key]);
          }
        }
      });
      that.languageTranslateByArr(newTextArr, title);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, title) {
      let that = this;
      this.$parent.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, title);
        },
        (res) => {}
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, title) {
      let that = this;
      data.forEach((v, i) => {
        if (title == "type_name") {
          that.headerBar[i].type_name = v.translation;
        }
        if (title == "title") {
          that.forumList[i].title = v.translation;
        }
        if (title == "detail") {
          that.forumList[i].detail = v.translation;
        }
      });
    },
    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArr = newpagetextArr;
      });
    },
  },
  mounted() {
    let that = this;
    let url = window.location.href
    // console.log("url",url)
    localStorage.setItem("url",url)
    // 获取论坛类型
    that.getUserBlogType();
    that.languageTranslateByArrs(that.pageTextArr);
  },
};
</script>


// WEBPACK FOOTER //
// src/view/forumManagement.vue